var _linearGradient;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconHowToPlay = function SvgIconHowToPlay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    className: "nav-icon",
    x: "0px",
    y: "0px",
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    style: {
      enableBackground: "new 0 0 35 35"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137128549877965585280000004673208803050480521_",
    gradientUnits: "userSpaceOnUse",
    x1: 17.5,
    y1: 35,
    x2: 17.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    className: "icon-gradient-top"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    className: "icon-gradient-bottom"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000137128549877965585280000004673208803050480521_)"
    },
    d: "M17.5,35C7.9,35,0,27.1,0,17.5     S7.9,0,17.5,0S35,7.9,35,17.5S27.1,35,17.5,35z M17.5,3C9.5,3,3,9.5,3,17.5S9.5,32,17.5,32S32,25.5,32,17.5S25.5,3,17.5,3z     M17.7,7.1c1.4,0,2.6,0.2,3.7,0.6c1,0.4,1.9,1,2.5,1.8c0.6,0.8,0.9,1.8,0.9,2.9c0,1.2-0.3,2.2-0.8,3c-0.5,0.8-1.2,1.4-2.1,1.8     C21,17.7,20.1,18,19,18.1l-0.1,3.1h-3.1v-4.6c1.4-0.2,2.6-0.4,3.4-0.7c0.8-0.3,1.4-0.7,1.7-1.1c0.3-0.5,0.5-1,0.5-1.7     c0-0.6-0.1-1.2-0.4-1.6c-0.3-0.5-0.7-0.8-1.3-1c-0.6-0.2-1.3-0.4-2.1-0.4c-1.2,0-2.2,0.3-2.9,1c-0.8,0.7-1.2,1.6-1.3,2.8l-3-1.4     c0.2-1.1,0.7-2,1.3-2.8c0.7-0.8,1.5-1.4,2.5-1.9C15.1,7.4,16.3,7.1,17.7,7.1z M17.3,23.6c0.7,0,1.2,0.2,1.7,0.6     c0.4,0.4,0.6,0.9,0.6,1.6s-0.2,1.2-0.6,1.6c-0.4,0.4-1,0.6-1.7,0.6c-0.7,0-1.2-0.2-1.6-0.6c-0.4-0.4-0.6-0.9-0.6-1.6     s0.2-1.2,0.6-1.6C16.1,23.8,16.7,23.6,17.3,23.6z"
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconHowToPlay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-how-to-play.2c1f6928.svg";
export { ForwardRef as ReactComponent };